module.exports = __webpack_public_path__ + "static/media/orange-and-white.540d6f7a.svg";